(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["whatsapp-order"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.wa-order');
    if (!link) return;

    const phone = link.dataset.waPhone;
    const prefix = link.dataset.waPrefix || '';
    const title = link.dataset.waProduct || '';
    if (!phone || !title) return;

    const map = link.parentElement?.querySelector('.wa-order__variants');
    const variantId = new URLSearchParams(window.location.search).get('variant');

    let variantTitle = '';
    if (map && variantId) {
      try {
        variantTitle = JSON.parse(map.textContent)[variantId] || '';
      } catch (error) {
        variantTitle = '';
      }
    }

    let message = prefix + ' ' + title;
    if (variantTitle && variantTitle !== 'Default Title') message += ' (' + variantTitle + ')';
    message += ' ' + window.location.origin + window.location.pathname;
    if (variantId) message += '?variant=' + variantId;

    link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message.trim());
  });
  } catch(e) { console.error(e); }
})();

})();
